import { render, staticRenderFns } from "./CBICertificate.vue?vue&type=template&id=e406589a&scoped=true"
import script from "./CBICertificate.vue?vue&type=script&lang=js"
export * from "./CBICertificate.vue?vue&type=script&lang=js"
import style0 from "./CBICertificate.vue?vue&type=style&index=0&id=e406589a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e406589a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
